import usePermissions from '@/hooks/usePermissions';
import { Box } from '@palmetto/palmetto-components';
import { NavLink } from 'react-router-dom';

import { ReviewQueueRoute, UserPermissions } from 'types';

export const HOLD_QUEUE_PATH = `/queue/${ReviewQueueRoute.holdMotion}`;
export const PROGRAM_ENABLEMENT_PATH = `${HOLD_QUEUE_PATH}/program-enablement`;

const LINK_STYLE = { textDecoration: 'none', fontWeight: '500' };
const TAB_HOVER = { color: 'primary' as const };
const TAB_STYLE = { transitionDuration: '0s' };

const HoldMotionTab = ({ to, label, end }: { to: string; label: string; end?: boolean }) => (
  <NavLink to={to} style={LINK_STYLE} end={end}>
    {({ isActive }) => (
      <Box as="span" padding="md" className={isActive ? 'tab-active' : ''} hover={TAB_HOVER} style={TAB_STYLE}>
        {label}
      </Box>
    )}
  </NavLink>
);

export const HoldMotionTabs = () => {
  const userPermissions = usePermissions();
  const isQCSuperAdmin = userPermissions.includes(UserPermissions.lightReachQCSuperAdmin);

  return (
    <Box direction="row" borderWidth="0 0 xs 0" borderColor="separator">
      {/* `end` keeps the Hold Queue tab inactive on its own nested Program Enablement route. */}
      <HoldMotionTab to={HOLD_QUEUE_PATH} label="Hold Queue" end />
      {isQCSuperAdmin && <HoldMotionTab to={PROGRAM_ENABLEMENT_PATH} label="Program Enablement" />}
    </Box>
  );
};
